import { useState, useRef } from 'react';
import css from './index.module.scss';
import EFArrowCircle from '@/components/UI/svg/CSR/Icons/EFArrowCircle';

export default function Swiper({
    gap,
    itemWidth,
    title,
    btnPosition = 'top',
    children,
    className = '',
    isRightAlign = false,
    isStepByStep,
    itemNum,
}: {
    gap: number;
    itemWidth: number;
    title?: string | JSX.Element;
    btnPosition?: string;
    children: JSX.Element[] | JSX.Element;
    className?: string;
    isRightAlign?: boolean;
    isStepByStep?: boolean;
    itemNum?: number;
}) {
    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const listBox = useRef<HTMLDivElement | null>(null);

    const [listLeft, setListLeft] = useState<number>(0);
    const [index, setIndex] = useState<number>(0);

    const leftDisable = isRightAlign ? listLeft == 0 : index <= 0;

    const rightDisable = isRightAlign ? listLeft != 0 : index <= 0;

    const buttonBox = (
        <div className="buttonWrapper">
            <div className="swiperButton" onClick={() => handleClick('right', leftDisable)}>
                <EFArrowCircle className="swiperButtonLeft" opacity={leftDisable ? '' : '1'} />
            </div>
            <div className="swiperButton" onClick={() => handleClick('left', rightDisable)}>
                <EFArrowCircle className="swiperButtonRight" opacity={rightDisable ? '' : '1'} />
            </div>
        </div>
    );

    const handlePrev = () => {
        if (index <= 0) return;
        if (index > 0) {
            const translateX = (itemWidth + gap) * (index - 1);
            setListLeft(-translateX);
        } else {
            const translateX = listBox.current.offsetWidth - gap - wrapperRef.current.offsetWidth;
            setListLeft(-translateX);
        }
        setIndex(index - 1);
    };

    const handleNext = () => {
        if (index >= Number(itemNum) - 1) return;
        if (index < Number(itemNum) - 2) {
            const translateX = (itemWidth + gap) * (index + 1);
            setListLeft(-translateX);
        } else {
            const translateX = listBox.current.offsetWidth - gap - wrapperRef.current.offsetWidth;
            setListLeft(-translateX);
        }
        setIndex(index + 1);
    };

    const handleClick = (direction?: string, isDisable?: boolean) => {
        if (isDisable) return;

        if (isRightAlign) {
            if (direction == 'left') {
                const translateX = listBox.current.offsetWidth - gap - wrapperRef.current.offsetWidth;
                setListLeft(-translateX);
            } else {
                setListLeft(0);
            }
            return;
        }

        const curIndex = direction == 'left' ? index - 1 : index + 1;
        const distance = itemWidth + gap;

        setListLeft(curIndex * distance);
        setIndex(curIndex);
    };

    return (
        <div className={`${css.csr_pc_swiper} ${className}`}>
            <div className="container topBtnBox">
                <div>{title}</div>
                {btnPosition == 'top' && !isStepByStep && buttonBox}
                {btnPosition == 'top' && isStepByStep && (
                    <div className="buttonWrapper">
                        <div className="swiperButton" onClick={() => handlePrev()}>
                            <EFArrowCircle className="swiperButtonLeft" opacity={index <= 0 ? '' : '1'} />
                        </div>
                        <div className="swiperButton" onClick={() => handleNext()}>
                            <EFArrowCircle className="swiperButtonRight" opacity={index >= Number(itemNum) - 1 ? '' : '1'} />
                        </div>
                    </div>
                )}
            </div>
            <div className="container" ref={wrapperRef}>
                <div
                    className="listBox"
                    ref={listBox}
                    style={{
                        transform: `translateX(${listLeft}px)`,
                    }}
                >
                    {children}
                </div>
            </div>
            {btnPosition == 'bottom' && <div className="container btnBox">{buttonBox}</div>}
        </div>
    );
}
